import { DirectoryRecordData } from 'api/types/data';
import { OrderOperationType } from 'api/types/entity';
import { getDirectoryFieldValue } from 'modules/account/common/helpers';

import { useField } from '../../../forms/orderForm';
import { useOrderContext } from '../../../providers/OrderProvider/useOrderContext';

export const useFinancialInstrumentSection = () => {
  const { schemas, isDisabledDirectoryFreeSolo, directories, orderType } =
    useOrderContext();

  const { financialInstruments } = directories;

  const { helpers: securityTypeHelpers } = useField(
    'financialInstrument.securityType'
  );
  const { helpers: issuerHelpers } = useField('financialInstrument.issuer');

  const { helpers: nominalValueHelpers } = useField(
    'financialInstrument.nominalValue'
  );

  const isIsinFreeSolo = isDisabledDirectoryFreeSolo
    ? false
    : orderType === OrderOperationType.SecuritiesPurchase ||
      orderType === OrderOperationType.SecuritiesDeposit;

  const onChangeIsin = (
    params: {
      value: string;
      label: string;
      record?: DirectoryRecordData;
    } | null
  ) => {
    if (params?.record) {
      const { record } = params;

      const securityTypeField = record.fields.find(
        (field) => field.name === financialInstruments.securityType.fieldName
      );

      const schema = schemas?.find(
        (schema) =>
          schema.name === financialInstruments.isin.directorySchemaName
      );

      securityTypeHelpers.setValue(
        securityTypeField && schema
          ? getDirectoryFieldValue(
              securityTypeField,
              schema,
              schemas!
            )?.toString()
          : ''
      );

      const issuerField = record.fields.find(
        (field) => field.name === financialInstruments.issuer.fieldName
      );

      issuerHelpers.setValue(
        issuerField && schema
          ? getDirectoryFieldValue(issuerField, schema, schemas!)?.toString()
          : ''
      );

      const nominalValueField = record.fields.find(
        (field) => field.name === financialInstruments.nominalValue.fieldName
      );

      nominalValueHelpers.setValue(
        (nominalValueField?.value as string) || undefined
      );
    } else {
      securityTypeHelpers.setValue('');
      issuerHelpers.setValue('');
      nominalValueHelpers.setValue(undefined);
    }
  };

  return { onChangeIsin, isIsinFreeSolo, financialInstruments };
};
